module.exports = __webpack_public_path__ + "img/costOrange.9fea1f0d.png";